module.exports = __webpack_public_path__ + "img/8.c6ba7ba2.jpg";